import { ModuleDataType } from 'types/interfacePreviewTypes';

export const wippe_cii_schwarz_l_s: ModuleDataType = {
  outputPdf: null,
  userUploadedFilesDescriptions: [],
  userUploadedFiles: [],
  id: null,
  projectTitle: '',
  configuratorPreviewScreenshot: null,
  isSubmitted: false,
  createdAt: null,
  updatedAt: null,
  userInfo: {
    name: '',
    lastname: '',
    firma: '',
    email: '',
    telephoneNumber: '',
    clientNumber: null,
    comments: '',
    country: '',
    postalCode: '',
  },
  background: {
    active: true,
    type: 'image',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/miunskekonfigurator.appspot.com/o/images%2Fwippen-images%2Fmar-2-2025%2Fcii_schwarz_l_s.png?alt=media&token=fa2fc3de-679a-4944-9b65-f8831b4ffcf5',
    thumbnail: null,
  },
  rotation: '0',
  module: 'Contura II - Wippe schwarz mit Linse + Strichlinse',
  version: '1.0',
  elements: {
    symbols: {
      0: {
        active: false,
        color: '#0e1111',
        icon: null,
        variant: 'bottom',
      },
      1: {
        active: true,
        color: '#0e1111',
        icon: null,
        variant: 'top',
      },
    },
  },
};
